module.exports = __webpack_public_path__ + "static/media/YM29_3.a44d8077.jpg";